// Dependencies
import React from 'react';

// Modules
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

// App
import { getExternal } from '../../core/getNode';
import PostBody from '../../partials/postBody';
import { alertMessages } from '../../partials/alertMessages';
import Error from '../../partials/error';
import SkeletonSingleScreen from '../../partials/skeleton-screens/skeletonSingleScreen';
import { logCustomEvent } from "../../core/analytics";
import Reactions from "../../partials/comments/reactions";
import { favoritesContentType } from "../../utils/helpers";

// UI components
import SinglesHeader from '../../partials/singlesHeader';
import { Row } from "react-bootstrap";

export default function BlogSingle(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [post, setPost] = useState(null);
  
  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const params = useParams()
  const user = useSelector((state) => state).authReducer.user;
 
  const contentType = favoritesContentType('blogs');

  useEffect(() => {
    loadNode()
    // eslint-disable-next-line
  }, []);
  
  /**
   * @function setData
   * @description Updates the state of the component upon data retrieval
   * @param {object} _data
   * @param {object} _realm
   */

  const setData = (_data) => {
    setPost(_data);
    setIsLoading(false);
    setIsError(false);
  }

  /**
   * @function setError
   * @description Updates the state of the component upon an error
   * @param {boolean} _isError
   * @param {int} _errorStatus
   * @param {string} _errorMessage
   */
  const setError = (_isError, _errorStatus, _errorMessage) => {
    setIsLoading(false);
    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  const loadNode = () => {
    const id = params.id;
  
    if (id) {
      getContent(id);
    } else {
      setError(true, 0, alertMessages.contentError);
    }
  };

  /**
   * @function getContent
   * @description Retrieves the data from an API / Fallback to local realm object if there is no connection
   */
  const getContent = (id) => {
    let path = `https://companyapp.co.uk/wp-json/wp/v2/posts?include[]=${id}&_embed`;

    getExternal(path)
      .then((response) => {
        if (response.data.length > 0) {
          setData(response.data[0]);
          logCustomEvent('read', {
            nid: response.data[0].id,
            title: response.data[0].title.rendered,
          }, 'Blog');
        } else {
          setError(true, 200, alertMessages.noData);
        }
      })
      .catch((_error) => {
        setError(true, 200, 'Unknown error');
      });
  };

  const renderPostImage = (post) => {
    let hasImage = post?._embedded["wp:featuredmedia"].length > 0 ? true : false;

    if (hasImage) {
      return (
        <div className="article__image">
          <img src={`${post?._embedded['wp:featuredmedia'][0]['source_url']}`} alt={'img-' + post.id} />
        </div>
      );
    }
  };

  if (isLoading) {
    return <SkeletonSingleScreen />;
  } else {
    if (isError) {
      return (
        <Error
          status={errorStatus}
          message={errorMessage}
        />
      );
    } else {
      let category = 'Uncategorised';

      if (post?._embedded['wp:term'][0][0].name) {
        category = post?._embedded['wp:term'][0][0].name;
      }

      return (
        <main className="blogs single">
          <article className="article">
            <SinglesHeader 
              route={"/blogs"}
              backBtnText={"Companyapp Blogs"}
              category={category}
              timestamp={props?.date}
              title={post?.title.rendered}
              hash={null}
            />
            {renderPostImage(post)}
            <div className="article__body">
              {/* <div dangerouslySetInnerHTML={{__html: post.body}} /> */}
              <PostBody body={post?.content.rendered} />
            </div>
            {user && user.current_user && (
              <>
                <Row className="reaction-container gx-0">
                  <Reactions
                    user={user}
                    nid={parseInt(params.id, 10)}
                    contentType={contentType}
                    field_allow_reactions={post.field_allow_reactions}
                  />
                </Row>
              </>
            )}
          </article>
        </main>
      );
    }
  }
}
